const React = require("react");
const Layout = require("./src/components/layout").default;
const gsap = require("gsap").default;
const ScrollTrigger = require("gsap/ScrollTrigger").default;

gsap.registerPlugin(ScrollTrigger);

exports.wrapPageElement = ({ element }) => {
  return <Layout>{element}</Layout>
}